import * as React from "react";
import { useState } from "react";
import styled from "styled-components";
import LookupTableFormFields from "./lookup-table-form-fields";
import DataAdapterFormStep from "./adapter-step";
import CacheFormStep from "./cache-step";
import SummaryStep from "./summary-step";
const CenteredDiv = styled.div`
  max-width: 1250px;
  margin: 0 auto;
`;
function useSteps(activeStepKey = "lookup-table") {
  const [activeStep, setActiveStep] = useState(activeStepKey);
  const steps = [
    {
      key: "lookup-table",
      title: "Lookup Table",
      component: /* @__PURE__ */ React.createElement(CenteredDiv, null, /* @__PURE__ */ React.createElement(LookupTableFormFields, null))
    },
    {
      key: "cache",
      title: "Cache (required)",
      component: /* @__PURE__ */ React.createElement(CacheFormStep, null)
    },
    {
      key: "data-adapter",
      title: "Data Adapter (required)",
      component: /* @__PURE__ */ React.createElement(DataAdapterFormStep, null)
    },
    {
      key: "summary",
      title: "Summary",
      component: /* @__PURE__ */ React.createElement(SummaryStep, null)
    }
  ];
  return [steps, { activeStep, setActiveStep }];
}
export default useSteps;
